import req from '../req'
// 角色权限

// 获取角色列表接口
export function getRoleList (params) {
  return req.get('/salesperson/permissions/list', params)
}

// 获取权限列表
export function getAuthList (params) {
  return req.get('/salesperson/permissions/get-auth-list', params)
}

// 创建角色
export function createRole (params) {
  return req.post('/salesperson/permissions/save', params)
}

// 修改角色状态
export function changeRoleStatus (params) {
  return req.post('/salesperson/permissions/change-status', params)
}

// 删除角色
export function deleteRole (params) {
  return req.post('/salesperson/permissions/del-role', params)
}

// 绑定角色
export function bindRole (params) {
  return req.post('/salesperson/permissions/bind-role', params)
}

// 解绑角色
export function unBindRole (params) {
  return req.post('/salesperson/permissions/unbind-role', params)
}
